<clr-modal
  [clrModalOpen]="isModalOpen()"
  (clrModalOpenChange)="isModalOpen.set($event)"
  [clrModalClosable]="true"
  [clrModalSize]="'lg'">
  <h3 class="modal-title">
    {{ 'Tabelle verwalten' | mrTranslate }}
    @if (title()) {
      : {{ title() }}
    }
  </h3>
  <div class="modal-body d-f col gap-5 w-100-p" style="height: 55vh">
    <div
      class="d-f width100 clr-flex-column clr-flex-md-row clr-align-items-stretch clr-align-items-md-center gap-10 w-100-p">
      <div class="btn-group btn-icon">
        <button class="btn" (click)="selectedRow.set(null); bezeichnung.reset()">
          <clr-tooltip>
            <cds-icon clrTooltipTrigger shape="file" />
            <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
              {{ 'Neuen Eintrag hinzufügen' | mrTranslate }}
            </clr-tooltip-content>
          </clr-tooltip>
        </button>
        @if (!isRep) {
          <button class="btn btn-danger" [disabled]="!selectedRow()" (click)="deleteRow()">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="times" />
              <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                {{ 'den Eintrag löschen' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>
        }
      </div>
      <form id="base-bezeichnung-form" class="nm flex-1-10-auto width100" (ngSubmit)="bezeichnung.valid && onSubmit()">
        <clr-input-container class="nm flex-1-10-auto">
          <label class="clr-required-mark">{{ 'Bezeichnung' | mrTranslate }}</label>
          <input clrInput type="text" [formControl]="bezeichnung" />
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
        </clr-input-container>
      </form>
      <div class="btn-group btn-success nxm">
        <button type="submit" form="base-bezeichnung-form" class="btn btn-sm" [clrLoading]="loadState()">
          {{ (selectedRow() ? 'Speichern' : 'Erstellen') | mrTranslate }}
        </button>
      </div>
    </div>
    @if (isLoading()) {
      <clr-spinner class="centred" />
    } @else if (table().columns.length) {
      <clr-datagrid
        class="datagrid-compact fill-space"
        [deselectButton]="true"
        [clrDgRowSelection]="true"
        [clrDgItemsIdentityFn]="row => row?.ID"
        [clrDgSelectionType]="'single'"
        [clrDgSelected]="[selectedRow()]"
        (clrDgSelectedChange)="selectedRow.set($event[0])">
        @for (column of table().columns; track column.id) {
          <clr-dg-column [clrDgField]="column.id">
            <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
              {{ column.id | titlecase | mrTranslate }}
            </ng-container>
          </clr-dg-column>
        }
        <clr-dg-row *clrDgItems="let row of table().rows" [clrDgItem]="row">
          @for (cell of table().columns; track cell.id) {
            <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
          }
        </clr-dg-row>
        <clr-dg-footer>{{ table().rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
      </clr-datagrid>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn" (click)="isModalOpen.set(false)">
      {{ 'Schliessen' | mrTranslate }}
    </button>
  </div>
</clr-modal>
